import { DOMAINS, IMPORTANCE, SECTIONS } from '@repo/monitoring';
import { useSuspenseQuery } from '@tanstack/react-query';
import { API } from 'api';
import { apiBasePath, apiName } from 'assets/constants';
import { UseMicrobiomeAgeResponse } from './types/microbiome-age.types';

async function getMicrobiomeAge(kitId: string) {
  return API.get(
    apiName,
    `${apiBasePath}/microbiome-age/${kitId}`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.RESULTS,
        domain: DOMAINS.RESULTS,
        importance: IMPORTANCE.HIGH,
      },
      context: {
        kitId,
      },
    },
  );
}

export default function useMicrobiomeAge(kitId: string) {
  return useSuspenseQuery<UseMicrobiomeAgeResponse>({
    queryKey: [apiName, 'getMicrobiomeAge', kitId],
    queryFn: () => getMicrobiomeAge(kitId),
  });
}
